import { render, staticRenderFns } from "./BaseInlineErrors.vue?vue&type=template&id=452abc44&scoped=true&"
import script from "./BaseInlineErrors.vue?vue&type=script&lang=js&"
export * from "./BaseInlineErrors.vue?vue&type=script&lang=js&"
import style0 from "./BaseInlineErrors.vue?vue&type=style&index=0&id=452abc44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452abc44",
  null
  
)

export default component.exports